import { Flex, Form } from 'antd'
import { FormProps } from 'antd/lib'

import { PersonalDataCard } from 'src/features/cases'

import { PersonDemographicsCard } from '../../../PersonDemographics'

type Props = {
  isEditing?: boolean
  isCreating?: boolean
  isGuardian?: boolean
  showTutor?: boolean
  /** The civil and migration data card (Form 058-1/e field 6 patronymic, 11–14). */
  showDemographics?: boolean
} & FormProps

export const PersonalDetailsForm = ({
  form,
  isEditing = false,
  showTutor = false,
  isGuardian = false,
  isCreating,
  showDemographics = false,
  ...props
}: Props) => {
  const isViewOnly = !isCreating && !isEditing

  return (
    <Form
      layout="vertical"
      form={form}
      requiredMark={false}
      disabled={isCreating ? false : !isEditing}
      {...props}
    >
      <Flex vertical gap={16}>
        <PersonalDataCard
          isViewOnly={isViewOnly}
          form={form}
          disabled={!isCreating}
          isGuardian={isGuardian}
          isEditing={isEditing}
          showTutor={showTutor}
        />

        {showDemographics && <PersonDemographicsCard />}
      </Flex>
    </Form>
  )
}
